module.exports = __webpack_public_path__ + "images/emoji/accept.323778476fc6dcc02201.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/accept.png
// module id = jlOP
// module chunks = 24